export default "__VITE_ASSET__BSIC5Igu__"